export default "__VITE_ASSET__ChLUDFbW__"